import { ActionIcon, CheckIcon } from "@mantine/core";
import { FC } from "react";

interface Props {
  p?: number;
  size?: number;
  color?: string;
}

const CheckinPin: FC<Props> = ({p = 2, size = 10, color = "#4CAF50"}) => {
  return (
    <ActionIcon
      p={p}
      size={size}
      color={color}
      radius="50%">
      <CheckIcon />
    </ActionIcon>
  );
};

export default CheckinPin;